'use client';

interface BackButtonProps {
  children: React.ReactNode;
  className?: string;
}

export default function BackButton({ children, className }: BackButtonProps) {
  const handleGoBack = () => {
    if (typeof window !== 'undefined') {
      window.history.back();
    }
  };

  return (
    <button
      onClick={handleGoBack}
      className={className}
    >
      {children}
    </button>
  );
}
